export default "__VITE_ASSET__e037113e__"